import { InputAdornment, TextField } from "@material-ui/core";
import { Search as SearchIcon } from "@material-ui/icons";
import { noop } from "lodash";
import React, { PropsWithChildren, useMemo, useState } from "react";
import { t } from "ttag";
import { useStoreActions, useStoreState } from "../../models/RootStore";
import GroupSearchMenuItem from "./GroupSearchMenuItem";
import MenuItemIcon from "./MenuItemIcon";
import { useStyles } from "./UnitsMenu.style";

const containsText = (name: any, searchText: any) =>
  name?.toLowerCase().indexOf(searchText?.toLowerCase()) > -1;

const BacnetUnitsMenu: React.FC<PropsWithChildren<any>> = (
  props: PropsWithChildren<any>
) => {
  const c = useStyles();
  const { handleClose } = props;
  const updateSelections = useStoreActions((a) => a.selections.updateSelections);
  const selections = useStoreState((s) => s.selections.selections);
  const bacnetUnits = useStoreState((s) => s.selections.getUnitsBySelection("bacnetUnits", ""));
  const [searchText, setSearchText] = useState<any>("");

  const displayedBacnetUnits = useMemo(
    () => {
      const units = bacnetUnits.filter((option: any) => containsText(option?.title, searchText));
      if (units.length) {
        units.unshift({
          id: 'all',
          title: t`All BACnet Devices`
        });
      }
      return units;
    },
    [searchText, bacnetUnits]
  );

  const handleSelect = (id: string, type: any) => {
    updateSelections({ type, data: id });
    handleClose();
  };

  return (
    <div className={c.view}>
      <div className={c.main}>
        <div className={c.menuWrapper}>
          <TextField
            classes={{ root: c.textField }}
            size="small"
            variant="outlined"
            autoFocus
            placeholder="Type to search..."
            fullWidth
            InputProps={{
              className: c.input,
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ fill: "#aaa2aa" }} />
                </InputAdornment>
              )
            }}
            onChange={(e: any) => {
              setSearchText(e.target.value);
            }}
            onClick={(e: any) => e.stopPropagation()}
            onKeyDown={(e: any) => {
              if (e.key !== "Escape") {
                e.stopPropagation();
              }
            }}
          />

          {!!displayedBacnetUnits.length && <GroupSearchMenuItem
            title={t`BACnet Devices`}
            onClick={noop}
            numItems={displayedBacnetUnits.length - 1}
            className={c.indoor}
            isOpen={true}
          >
            {displayedBacnetUnits.map((unit: any) => (
              <MenuItemIcon
                key={unit.id}
                title={unit.title}
                onClick={(id: string) => handleSelect(id, "bacnetUnit")}
                unit={unit.id}
                isSelected={selections.bacnetUnitId === unit.id}
              />
            ))}
          </GroupSearchMenuItem>}
        </div>
      </div>
    </div>
  );
};

export default BacnetUnitsMenu;
